/**
 * Create and add child to DOM
 * @param {HTMLElement} parent
 * @param {string} nodeName
 * @param {string[]} attrs
 * @returns {HTMLElement}
 */
export function addChild(parent,nodeName,attrs){
  const elm = document.createElement(nodeName)
  Object.entries(attrs).forEach(([name,value])=>{
    ['textContent','innerHTML'].includes(name)
    ?elm[name] = value
    :elm.setAttribute(name,value)
  })
  parent.appendChild(elm)
  return elm
}

/**
 * Convert plain object literal to properties definition
 * as defined in https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperties
 * @param {object} o
 * @returns {object}
 */
export function propertiesToDefinition(o){
  return Object.entries(o).reduce((acc,[key,value])=>{
      acc[key] = {
        value
        ,writable: true
      }
      return acc
  },{})
}

/**
 * Select a rule from the stylesheet
 * @param {string} selector
 * @return {CSSRule}
 */
export function select(selector){
  let foundRule
  Array.from(document.styleSheets).forEach(sheet=>{
    try{
      !foundRule&&Array.from(sheet.cssRules).forEach(rule=>{
        rule.selectorText===selector&&(foundRule = rule)
      })
    }catch(err){/* prevent InvalidAccessError on external sources*/}
  })
  return foundRule
}


// WEBPACK FOOTER //
// ./src/js/util/index.js